<template>
  <section class="content-register-text">
    <Breadcrumb :links="links" :data="{type:  'FraseDiaria', name: phraseDiaryData?.title, id: phraseDiaryData?.id}"/>
    <form class="content-register-text-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12">
          <div class="content-input-default">
            <input type="text" v-model="phraseDiary.title" name="title" value="" placeholder="Título" required/>
          </div>
        </div>
        <div class="col-12">
          <div class="content-input-default">
            <textarea name="description" v-model="phraseDiary.description" placeholder="Descrição" required></textarea>
          </div>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Tarefas',
          routerName: 'Tasks'
        },
        {
          name: 'Menu',
          routerName: 'MenuTasks'
        },
        {
          name: 'Cadastrar Conteúdo',
          routerName: 'RegisterContents'
        },
        {
          name: 'Frase do dia',
          routerName: 'PhraseDiary'
        },
      ],
      phraseDiary: {
        id_user: '',
        id_task: '',
        title: '',
        description: '',
      }
    }
  },
  computed: {
    ...mapGetters('Tasks', ['currentTask']),
    ...mapGetters('User', ['user']),
    ...mapGetters({ phraseDiaryData: 'Tasks/phraseDiary' }),
  },
  components: {
    Breadcrumb,
  },
  methods: {
    ...mapActions('Tasks', ['registerPhraseDiary']),
    async handleSubmit(){
      let message = this.phraseDiary?.id ? 'Frase do dia editada com sucesso!' : 'Frase do dia cadastrada com sucesso!';

      this.phraseDiary.id_user = this.user.id;
      this.phraseDiary.id_task = this.currentTask.id;

      await this.registerPhraseDiary(this.phraseDiary);
      this.$router.push({ name: 'RegisterContents' })
      this.$swal.fire({
        icon: 'success',
        html: message,
      })
    },
  },
  async mounted() {
    if (Object.keys(await this.currentTask).length > 0){
      this.links[0].name = this.currentTask.name;
    }
    if (Object.keys(await this.phraseDiaryData).length > 0) {
      this.phraseDiary = this.phraseDiaryData;
      this.links[3].name = this.phraseDiary.title;
    }
  }
}
</script>

<style lang="scss" scoped>
.content-register-text {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px){
    margin-top: 50px;
  }
}
</style>
